import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerCertificazioneUnicaModalComponent } from './worker-certificazione-unica-modal';


export const WorkerCertificazioneUnicaModalModule: string = ng
    .module('worker-certificazione-unica-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerCertificazioneUnicaModalComponent', WorkerCertificazioneUnicaModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-certificazione-unica-modal/worker-certificazione-unica-modal.module.ts